import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ReactFlagsSelect from "react-flags-select";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { addToCart } from "../../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

// Validation schema
const validationSchema = Yup.object({
  country: Yup.string().required("Le pays est requis"),
});

function CustomsRebateCountry() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  const handleSubmit = async (values) => {
    await dispatch(
      addToCart({
        country: values.country,
      })
    );

    navigate("/customs-rebate-product-type");
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />

      <div className="container mt-3 text-center" style={{ maxWidth: "800px" }}>
        <h4 className="text-center mt-4 mb-4">
          Dans quel <span style={{ color: "#FF5500" }}>pays</span>{" "}
          souhaitez-vous obtenir votre{" "}
          <span style={{ color: "#FF5500" }}>abattement douanier</span> ?
        </h4>
      </div>

      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{ country: "" }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form
              className="w-100"
              style={{ textAlign: "left", maxWidth: "400px" }}
            >
              {/* Country selector */}
              <div className="mb-3">
                <ReactFlagsSelect
                  selected={values.country}
                  countries={["CM"]}
                  onSelect={(code) => {
                    setFieldValue("country", code);
                  }}
                  placeholder="Pays"
                  searchable
                  searchPlaceholder="Recherchez le pays"
                  className="w-100"
                />
                {errors.country && touched.country && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.country}
                  </div>
                )}
              </div>

              {/* Submit button */}
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default CustomsRebateCountry;
